import { render } from "./wnQueryCY.vue?vue&type=template&id=0512e77c&scoped=true"
import script from "./wnQueryCY.vue?vue&type=script&lang=js"
export * from "./wnQueryCY.vue?vue&type=script&lang=js"

import "./wnQueryCY.vue?vue&type=style&index=0&id=0512e77c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0512e77c"

export default script